import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import { FormattedMessage } from 'umi';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={<FormattedMessage id="pages.welcome.title" />}
      links={[
        {
          key: 'jetinno',
          title: <FormattedMessage id="pages.welcome.title" />,
          href: 'https://pro.ant.design',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
